const { MenuItem } = require('@mui/material');

export const states  = 
  [
      <MenuItem key={1} value={'آذربایجان شرقی'}>آذربایجان شرقی</MenuItem>,
      <MenuItem key={2} value={'آذربایجان غربی'}>آذربایجان غربی</MenuItem>,
      <MenuItem key={3} value={'اردبیل'}>اردبیل</MenuItem>,
      <MenuItem key={4} value={'اصفهان'}>اصفهان</MenuItem>,
      <MenuItem key={5} value={'البرز'}>البرز</MenuItem>,
      <MenuItem key={6} value={'ایلام'}>ایلام</MenuItem>,
      <MenuItem key={7} value={'بوشهر'}>بوشهر</MenuItem>,
      <MenuItem key={8} value={'تهران'}>تهران</MenuItem>,
      <MenuItem key={9} value={'چهارمحال بختیاری'}>چهارمحال و بختیاری</MenuItem>,
      <MenuItem key={10} value={'خراسان جنوبی'}>خراسان جنوبی</MenuItem>,
      <MenuItem key={11} value={'خراسان رضوی'}>خراسان رضوی</MenuItem>,
      <MenuItem key={12} value={'خراسان شمالی'}>خراسان شمالی</MenuItem>,
      <MenuItem key={13} value={'خوزستان'}>خوزستان</MenuItem>,
      <MenuItem key={14} value={'زنجان'}>زنجان</MenuItem>,
      <MenuItem key={15} value={'سمنان'}>سمنان</MenuItem>,
      <MenuItem key={16} value={'سیستان بلوچستان'}>سیستان و بلوچستان</MenuItem>,
      <MenuItem key={17} value={'فارس'}>فارس</MenuItem>,
      <MenuItem key={18} value={'قزوین'}>قزوین</MenuItem>,
      <MenuItem key={19} value={'قم'}>قم</MenuItem>,
      <MenuItem key={20} value={'کردستان'}>کردستان</MenuItem>,
      <MenuItem key={21} value={'کرمان'}>کرمان</MenuItem>,
      <MenuItem key={22} value={'کرمانشاه'}>کرمانشاه</MenuItem>,
      <MenuItem key={23} value={'کهگیلویه بویراحمد'}>کهگیلویه و بویراحمد</MenuItem>,
      <MenuItem key={24} value={'گرگان'}>گرگان</MenuItem>,
      <MenuItem key={25} value={'گیلان'}>گیلان</MenuItem>,
      <MenuItem key={26} value={'لرستان'}>لرستان</MenuItem>,
      <MenuItem key={27} value={'مازندران'}>مازندران</MenuItem>,
      <MenuItem key={28} value={'مرکزی'}>مرکزی</MenuItem>,
      <MenuItem key={29} value={'هرمزگان'}>هرمزگان</MenuItem>,
      <MenuItem key={30} value={'همدان'}>همدان</MenuItem>,
      <MenuItem key={31} value={'یزد'}>یزد</MenuItem>,
  ]

